import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { signup } from 'apa/actions';
import autobind from 'autobind-decorator';
import {Row, Col} from 'reactstrap';
import {Redirect} from 'react-router-dom';


@connect(
    state => ({
        errors: state.apa.errors,
        isAuthenticated: state.apa.isAuthenticated
    }),
    dispatch => ({
        signup: (data) => (dispatch(signup(data)))
    })
)
export default class Login extends Component {

    state = {
        code: '',
        username: '',
        password: '',
        password_repeat: '',
        captcha: 'test',
    }

    @autobind
    onSubmit(event) {
        event.preventDefault();
        const data = {...this.state, captcha: 'captcha'};
        this.props.signup(data)
    }


    render() {
        const { errors } = this.props
        const { non_field_errors } = errors;
        console.log(errors)
        if (this.props.isAuthenticated) {
            return <Redirect to="/training/welcome" />
        }
        return (
            <form className="form-signin" onSubmit={this.onSubmit}>
                <h1>Registrierung</h1>
                {non_field_errors && non_field_errors.map(
                    (error, index) => <p key={`error_${index}`} className='text-danger'>{error}</p>
                )}
                <div className="form-group">
                    <label htmlFor="code">
                        <FormattedMessage id="app.login.access_code" defaultMessage="Zugangscode" />
                    </label>
                    <input id="code" className="form-control" type="text" onChange={
                        e => this.setState({ code: e.target.value })
                    } required={true} autoFocus={true} />
                </div>
                <div className="form-group">
                    <label htmlFor="username">
                        <FormattedMessage id="app.login.username" defaultMessage="Benutzername" />
                    </label>
                    <input id="username" className="form-control" type="text" onChange={
                        e => this.setState({ username: e.target.value })
                    } required={true} autoFocus={true} />
                </div>
                <div className="form-group">
                    <label htmlFor="password1">
                        <FormattedMessage id="app.login.password" defaultMessage="Passwort" />
                    </label>
                    <input id="password1" className="form-control" type="password" onChange={
                        e => this.setState({ password: e.target.value })
                    } required={true} />
                </div>
                <div className="form-group">
                    <label htmlFor="repeatPassword">
                        <FormattedMessage id="app.login.repeatPassword" defaultMessage="Passwort (Wiederholung)" />
                    </label>
                    <input id="repeatPassword" className="form-control" type="password" onChange={
                        e => this.setState({ password_repeat: e.target.value })
                    } required={true} />
                </div>
                <button type="submit" className="btn btn-block btn-primary">
                    <FormattedMessage id="app.login.login_btn" defaultMessage="Registrieren" />
                </button>
            </form>
        )
    }
}

Login.propTypes = {
    login: PropTypes.func,
    isAuthenticated: PropTypes.bool,
    errors: PropTypes.object
}
